import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
	Modal,
	ModalBody,
	Nav,
	NavItem,
	TabContent,
	TabPane,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
	Form,
	FormGroup,
	Row,
	Col,
	NavLink,
	FormFeedback,
	Label,
} from "reactstrap";
import Select from "react-select";
import userService from "services/UserService";
import organizationalStructureService from "services/OrganizationalStructureService";
import Swal from "sweetalert2";
import OrganizationalStructure from "./components/OrganizationalStructure";
import Functionogram from "./components/Functionogram";
import CaracteristicaCargo from "./components/CaracteristicaCargo";
import MyDocument from "./components/PrintPdf";
import MigrateItensToNewDepartmentModal from "./components/MigrateItensToNewDepartmentModal";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const ModalCreateEditItem = ({
	show,
	onCloseClick,
	data,
	updateData,
	onDuplicate,
}) => {
	const [activeTab, setActiveTab] = useState(1);
	const [showMigrationModal, setShowMigrationModal] = useState(false);
	const [migrationData, setMigrationData] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isDuplicatedDepartment, setIsDuplicatedDepartment] = useState(false);
	const [originalDepartmentId, setOriginalDepartmentId] = useState(null);

	// Reinicia o estado activeTab quando o modal é aberto
	useEffect(() => {
		if (show) {
			setActiveTab(1); // Define a aba ativa como 1 quando o modal é aberto
			// Verifica se este modal foi aberto via duplicação
			setIsDuplicatedDepartment(data?.isDuplicated || false);
			setOriginalDepartmentId(data?.originalId || null);
		}
	}, [show, data]); // Executa o efeito sempre que `show` ou `data` mudar

	const handleCloseWithConfirmation = () => {
		// Só mostra confirmação quando está criando um novo registro (sem ID)
		if (!data?.id) {
			SendaCustomSwal.fire({
				iconHtml: '<i class="warning-icon"></i>',
				title: "Atenção!",
				text: "Deseja salvar as alterações antes de fechar?",
				showCancelButton: true,
				confirmButtonText: "Salvar e Fechar",
				cancelButtonText: "Fechar",
				customClass: {
					confirmButton: "custom-confirm-button",
					cancelButton: "custom-cancel-button",
				},
			}).then((result) => {
				if (result.isConfirmed) {
					// Usuário quer salvar antes de fechar
					const form = document.querySelector('form');
					if (form) {
						const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
						form.dispatchEvent(submitEvent);
					}
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					// Usuário quer fechar sem salvar
					onCloseClick();
				}
			});
		} else {
			// Se está editando (tem ID), fecha normalmente
			onCloseClick();
		}
	};

	const handleDuplicatedDepartmentSaved = async (newDepartmentId) => {
		// Só executa se for um departamento duplicado e ainda não mostrou o modal
		if (
			isDuplicatedDepartment &&
			originalDepartmentId &&
			!showMigrationModal
		) {
			try {
				setIsLoading(true);

				// Aplica loading de 1 segundo (igual ao duplicar)
				await new Promise((resolve) => setTimeout(resolve, 1000));

				setMigrationData({
					originalDepartmentId: originalDepartmentId,
					newDepartmentId: newDepartmentId,
				});
				setShowMigrationModal(true);

				// Marca que já foi processado para não aparecer novamente
				setIsDuplicatedDepartment(false);
			} catch (error) {
				console.error("Erro ao preparar modal de migração:", error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const handleCloseMigrationModal = () => {
		setShowMigrationModal(false);
		setMigrationData(null);
	};

	return (
		<>
			<Modal
				size="sm"
				isOpen={show}
				toggle={handleCloseWithConfirmation}
				centered={true}
				style={{ minWidth: 1200 }}
			>
				<div className="modal-content">
					<ModalBody className="px-4 py-3">
						<Nav tabs className="mb-4">
							<NavItem>
								<NavLink
									active={activeTab === 1}
									onClick={() => setActiveTab(1)}
								>
									Estrutura Organizacional
								</NavLink>
							</NavItem>
							{data.id && (
								<>
									<NavItem>
										<NavLink
											active={activeTab === 2}
											onClick={() => setActiveTab(2)}
										>
											Funcionograma
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											active={activeTab === 3}
											onClick={() => setActiveTab(3)}
										>
											Características do Cargo
										</NavLink>
									</NavItem>
								</>
							)}
						</Nav>

						{activeTab === 1 && (
							<OrganizationalStructure
								show={show}
								onCloseClick={onCloseClick}
								data={data}
								updateData={updateData}
								onDuplicate={onDuplicate}
								onDuplicatedDepartmentSaved={
									handleDuplicatedDepartmentSaved
								}
							/>
						)}

						{activeTab === 2 && (
							<Functionogram
								onCloseClick={onCloseClick}
								data={data}
							/>
						)}
						{activeTab === 3 && (
							<CaracteristicaCargo
								onCloseClick={onCloseClick}
								data={data}
							/>
						)}
					</ModalBody>
				</div>
			</Modal>

			{/* Modal de Migração - Agora muito mais simples */}
			{migrationData && (
				<MigrateItensToNewDepartmentModal
					isOpen={showMigrationModal}
					onClose={handleCloseMigrationModal}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
					originalDepartmentId={migrationData.originalDepartmentId}
					newDepartmentId={migrationData.newDepartmentId}
				/>
			)}
		</>
	);
};

ModalCreateEditItem.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
	updateData: PropTypes.func,
	onDuplicate: PropTypes.func,
	onDuplicatedDepartmentSaved: PropTypes.func,
};
export default ModalCreateEditItem;
